import { render, staticRenderFns } from "./Certidao.vue?vue&type=template&id=5c21d8a8&"
import script from "./Certidao.vue?vue&type=script&lang=js&"
export * from "./Certidao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports